module.exports = {
  development: {
    VUE_APP_VERSION: 'development',
    VUE_APP_ENDPOINT_API: 'http://localhost:3000',
    VUE_APP_TVI_LOGIN: 'http://localhost:8080/callback',
    VUE_APP_LOCATION: 'http://localhost:8080',
    VUE_APP_TVI_LOGIN_CLINET_ID: 'gXScVG07lx24ecD9ehwt6dblr3ladj65',
    VUE_APP_TMB_REDIRECT: 'http://localhost:3000/authlanding?client_name=OAuth20Client',
    VUE_APP_TMB_CLIENT_ID: 'a3bc15ff-13c6-4db1-9cba-97fc965e7615',
    VUE_APP_TMB_CALL_ADFS: 'https://servicesdd.tmbbank.com/adfs/oauth2/token',
    VUE_APP_TMB_REDIRECT_POST: 'http://localhost:8080/authlanding',
    VUE_APP_PATH_API: 'http://localhost:3000/',
    // VUE_APP_PATH_API: 'https://api.alpha.tmbhealth.thaivivat.co.th/',
    VUE_APP_TMB_LOGIN_URL: 'https://servicesdd.tmbbank.com/adfs/oauth2/authorize',
    VUE_APP_TMB_LOGOUT_URL: 'https://servicesdd.tmbbank.com/adfs/ls/?wa=wsignout1.0&wreply=',
    OMISE_PUBLIC_KEY: 'pkey_test_5jukabof9e30x2hergs',
  },
  alpha: {
    VUE_APP_VERSION: 'alpha',
    VUE_APP_LOCATION: 'https://alpha.tmbhealth.thaivivat.co.th',
    VUE_APP_ENDPOINT_API: 'https://api.alpha.tmbhealth.thaivivat.co.th',
    VUE_APP_TVI_LOGIN: 'https://alpha.tmbhealth.thaivivat.co.th/callback',
    VUE_APP_TVI_LOGIN_CLINET_ID: 'gXScVG07lx24ecD9ehwt6dblr3ladj65',
    VUE_APP_TMB_REDIRECT:
      'https://alpha.tmbhealth.thaivivat.co.th/authlanding?client_name=OAuth20Client',
    VUE_APP_TMB_CLIENT_ID: 'a3bc15ff-13c6-4db1-9cba-97fc965e7615',
    VUE_APP_TMB_CALL_ADFS: 'https://servicesdd.tmbbank.com/adfs/oauth2/token',
    VUE_APP_TMB_REDIRECT_POST: 'https://alpha.tmbhealth.thaivivat.co.th/authlanding',
    VUE_APP_PATH_API: 'https://api.alpha.tmbhealth.thaivivat.co.th/',
    VUE_APP_TMB_LOGIN_URL: 'https://servicesdd.tmbbank.com/adfs/oauth2/authorize',
    VUE_APP_TMB_LOGOUT_URL: 'https://servicesdd.tmbbank.com/adfs/ls/?wa=wsignout1.0&wreply=',
    OMISE_PUBLIC_KEY: 'pkey_test_5jukabof9e30x2hergs',
  },
  beta: {
    VUE_APP_VERSION: 'beta',
    VUE_APP_LOCATION: 'https://beta.tmbhealth.thaivivat.co.th',
    VUE_APP_ENDPOINT_API: 'https://api.beta.tmbhealth.thaivivat.co.th',
    VUE_APP_TVI_LOGIN: 'https://beta.tmbhealth.thaivivat.co.th/callback',
    VUE_APP_TVI_LOGIN_CLINET_ID: 'Ixv681nQXBN71qsTEvPCbUcJruJrWQR0',
    VUE_APP_TMB_REDIRECT:
      'https://beta.tmbhealth.thaivivat.co.th/authlanding?client_name=OAuth20Client',
    VUE_APP_TMB_CLIENT_ID: '7cbac7e6-fdf7-4f24-96dd-8e04fc379aec',
    VUE_APP_TMB_CALL_ADFS: 'https://servicesdd.tmbbank.com/adfs/oauth2/token',
    VUE_APP_TMB_REDIRECT_POST: 'https://beta.tmbhealth.thaivivat.co.th/authlanding',
    VUE_APP_PATH_API: 'https://api.beta.tmbhealth.thaivivat.co.th/',
    VUE_APP_TMB_LOGIN_URL: 'https://servicesdd.tmbbank.com/adfs/oauth2/authorize',
    VUE_APP_TMB_LOGOUT_URL: 'https://servicesdd.tmbbank.com/adfs/ls/?wa=wsignout1.0&wreply=',
    OMISE_PUBLIC_KEY: 'pkey_test_5jukabof9e30x2hergs',
  },
  pilot: {
    VUE_APP_VERSION: 'pilot',
    VUE_APP_LOCATION: 'https://pilot-tmbhealth.thaivivat.co.th',
    VUE_APP_ENDPOINT_API: 'https://api.pilot-tmbhealth.thaivivat.co.th',
    VUE_APP_TVI_LOGIN: 'https://pilot-tmbhealth.thaivivat.co.th/callback',
    VUE_APP_TVI_LOGIN_CLINET_ID: 'Bh9NnckNvMk6s7P7diFf0ZHbGDLxgtZc',
    VUE_APP_TMB_REDIRECT:
      'https://pilot-tmbhealth.thaivivat.co.th/authlanding?client_name=OAuth20Client',
    VUE_APP_TMB_CLIENT_ID: 'b1e739ed-edc8-4f9f-bd0c-66c52760b0e7',
    VUE_APP_TMB_CALL_ADFS: 'https://services.tmbbank.com/adfs/oauth2/token',
    VUE_APP_TMB_REDIRECT_POST: 'https://pilot-tmbhealth.thaivivat.co.th/authlanding',
    VUE_APP_PATH_API: 'https://api.pilot-tmbhealth.thaivivat.co.th/',
    VUE_APP_TMB_LOGIN_URL: 'https://services.tmbbank.com/adfs/oauth2/authorize',
    VUE_APP_TMB_LOGOUT_URL: 'https://services.tmbbank.com/adfs/ls/?wa=wsignout1.0&wreply=',
    OMISE_PUBLIC_KEY: 'pkey_5psn7yotso9d73b4d3e',
  },
  production: {
    VUE_APP_VERSION: 'production',
    VUE_APP_LOCATION: 'https://tmbhealth.thaivivat.co.th',
    VUE_APP_ENDPOINT_API: 'https://api.tmbhealth.thaivivat.co.th',
    VUE_APP_TVI_LOGIN: 'https://tmbhealth.thaivivat.co.th/callback',
    VUE_APP_TVI_LOGIN_CLINET_ID: 'Bh9NnckNvMk6s7P7diFf0ZHbGDLxgtZc',
    VUE_APP_TMB_REDIRECT: 'https://tmbhealth.thaivivat.co.th/authlanding?client_name=OAuth20Client',
    VUE_APP_TMB_CLIENT_ID: 'a3bc15ff-13c6-4db1-9cba-97fc965e7615',
    VUE_APP_TMB_CALL_ADFS: 'https://services.tmbbank.com/adfs/oauth2/token',
    VUE_APP_TMB_REDIRECT_POST: 'https://tmbhealth.thaivivat.co.th/authlanding',
    VUE_APP_PATH_API: 'https://api.tmbhealth.thaivivat.co.th/',
    VUE_APP_TMB_LOGIN_URL: 'https://services.tmbbank.com/adfs/oauth2/authorize',
    VUE_APP_TMB_LOGOUT_URL: 'https://services.tmbbank.com/adfs/ls/?wa=wsignout1.0&wreply=',
    OMISE_PUBLIC_KEY: 'pkey_5psn7yotso9d73b4d3e',
  },
}
